import SpaceBetween from '@risk-smart/themed-cloudscape-components/space-between';
import Table from '@risksmart-app/components/src/table';
import type { FC } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ExportButton from 'src/components/export-button';
import { PageLayout } from 'src/layouts';

import {
  useGetAppetitesGroupedByImpact,
  useGetImpactRatings,
} from '@/hooks/queries';
import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';
import { getCounter } from '@/utils/collectionUtils';

import { useGetCollectionTableProps } from './config';
import ImpactRatingModal from './ImpactRatingModal';
import { ImpactRatingRegisterToolbar } from './ImpactRatingRegisterToolbar';

const Page: FC = () => {
  const [selectedRatingId, setSelectedRatingId] = useState<string>();
  const objectToolbarEnabled = useIsFeatureFlagEnabled('dynamic_forms');
  const { t: st } = useTranslation(['common'], { keyPrefix: 'impactRatings' });
  const { data, loading } = useGetImpactRatings({
    queryArgs: {},
  });

  const { data: impactAppetites, loading: loadingImpactAppetites } =
    useGetAppetitesGroupedByImpact({ queryArgs: {} });

  const tableProps = useGetCollectionTableProps(
    data?.impact_rating,
    impactAppetites?.impact,
    (item) => setSelectedRatingId(item.Id)
  );

  const counter = getCounter(
    tableProps.totalItemsCount,
    loading || loadingImpactAppetites
  );
  const title = st('register_title');

  return (
    <PageLayout
      helpTranslationKey={'impactRatings.registerHelp'}
      title={title}
      counter={counter}
      // Object-level toolbar (CUS-155) — flag-gated. Mounted only when the flag
      // is on, so `useExportOptions` runs on exactly one path (toolbar vs the
      // legacy ExportButton) rather than both.
      headerOverride={
        objectToolbarEnabled ? (
          <ImpactRatingRegisterToolbar
            title={title}
            counter={counter}
            tableProps={tableProps}
          />
        ) : undefined
      }
      actions={
        <SpaceBetween direction={'horizontal'} size={'xs'}>
          <ExportButton tableProps={tableProps} entityLabel={title} />
        </SpaceBetween>
      }
    >
      <Table {...tableProps} loading={loading || loadingImpactAppetites} />
      {selectedRatingId && (
        <ImpactRatingModal
          impactRatingId={selectedRatingId}
          onDismiss={() => setSelectedRatingId(undefined)}
          onSaving={() => Promise.reject()}
        />
      )}
    </PageLayout>
  );
};

export default Page;
